import styled, { css } from 'styled-components';

export const Container = styled.i`
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icons' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  display: inline-block;
  vertical-align: middle;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  ${(props) =>
    props.symbol === 'arrow-down' &&
    css`
      &:before {
        content: '\\e000';
      }
    `}

  ${(props) =>
    props.symbol === 'arrow-up' &&
    css`
      &:before {
        content: '\\e001';
      }
    `}

  ${(props) =>
    props.symbol === 'arrow-left' &&
    css`
      &:before {
        content: '\\e002';
      }
    `}

  ${(props) =>
    props.symbol === 'arrow-right' &&
    css`
      &:before {
        content: '\\e003';
      }
    `}

  ${(props) =>
    props.symbol === 'handle' &&
    css`
      &:before {
        content: '\\e004';
      }
    `}

  ${(props) =>
    props.symbol === 'info' &&
    css`
      &:before {
        content: '\\e005';
      }
    `}

  ${(props) =>
    props.symbol === 'close' &&
    css`
      &:before {
        content: '\\e006';
      }
    `}

  ${(props) =>
    props.symbol === 'menu' &&
    css`
      &:before {
        content: '\\e007';
      }
    `}

  ${(props) =>
    props.symbol === 'time' &&
    css`
      &:before {
        content: '\\e008';
      }
    `}

  ${(props) =>
    props.symbol === 'twitter' &&
    css`
      &:before {
        content: '\\e009';
      }
    `}

  ${(props) =>
    props.symbol === 'telegram' &&
    css`
      &:before {
        content: '\\e00a';
      }
    `}

  ${(props) =>
    props.symbol === 'medium' &&
    css`
      &:before {
        content: '\\e00b';
      }
    `}

  ${(props) =>
    props.symbol === 'linkedin' &&
    css`
      &:before {
        content: '\\e00c';
      }
    `}

  ${(props) =>
    props.symbol === 'github' &&
    css`
      &:before {
        content: '\\e00d';
      }
    `}

  ${(props) =>
    props.symbol === 'addresses' &&
    css`
      &:before {
        content: '\\e900';
      }
    `}

  ${(props) =>
    props.symbol === 'derivatives' &&
    css`
      &:before {
        content: '\\e901';
      }
    `}

  ${(props) =>
    props.symbol === 'distribution' &&
    css`
      &:before {
        content: '\\e902';
      }
    `}

  ${(props) =>
    props.symbol === 'entities' &&
    css`
      &:before {
        content: '\\e903';
      }
    `}

  ${(props) =>
    props.symbol === 'exchanges' &&
    css`
      &:before {
        content: '\\e904';
      }
    `}

  ${(props) =>
    props.symbol === 'fees' &&
    css`
      &:before {
        content: '\\e905';
      }
    `}

  ${(props) =>
    props.symbol === 'folder-open' &&
    css`
      &:before {
        content: '\\e906';
      }
    `}

  ${(props) =>
    props.symbol === 'folder-closed' &&
    css`
      &:before {
        content: '\\e907';
      }
    `}

  ${(props) =>
    props.symbol === 'lifespan' &&
    css`
      &:before {
        content: '\\e908';
      }
    `}

  ${(props) =>
    props.symbol === 'profit-loss' &&
    css`
      &:before {
        content: '\\e909';
      }
    `}

  ${(props) =>
    props.symbol === 'market-indicators' &&
    css`
      &:before {
        content: '\\e90a';
      }
    `}

  ${(props) =>
    props.symbol === 'miners' &&
    css`
      &:before {
        content: '\\e90b';
      }
    `}

  ${(props) =>
    props.symbol === 'network-stats' &&
    css`
      &:before {
        content: '\\e90c';
      }
    `}

  ${(props) =>
    props.symbol === 'price-and-marketcap' &&
    css`
      &:before {
        content: '\\e90d';
      }
    `}

  ${(props) =>
    props.symbol === 'ratios' &&
    css`
      &:before {
        content: '\\e90e';
      }
    `}

  ${(props) =>
    props.symbol === 'long-short-term-hodlers' &&
    css`
      &:before {
        content: '\\e90f';
      }
    `}

  ${(props) =>
    props.symbol === 'unspent-spent-outputs' &&
    css`
      &:before {
        content: '\\e910';
      }
    `}

  ${(props) =>
    props.symbol === 'supply' &&
    css`
      &:before {
        content: '\\e911';
      }
    `}

  ${(props) =>
    props.symbol === 'transactions' &&
    css`
      &:before {
        content: '\\e912';
      }
    `}

  ${(props) =>
    props.symbol === 'volume' &&
    css`
      &:before {
        content: '\\e913';
      }
    `}

  ${(props) =>
    props.symbol === 'indexes' &&
    css`
      &:before {
        content: '\\e914';
      }
    `}

  ${(props) =>
    props.symbol === 'favorites' &&
    css`
      &:before {
        content: '\\e915';
      }
    `}

  ${(props) =>
    props.symbol === 'internal' &&
    css`
      &:before {
        content: '\\e916';
      }
    `}

`;
